<template>
    <Header ueberschrift="Eurorescue" v-show="randVisible" />
    <div id="eurorescue">
        <h1>Eurorescue</h1>
        <h2>Springen Sie auf Eurorescue ab, um aktuelle Rettungskarten zu erhalten</h2>
        <br>
        jetzt abspringen:
        <br><br>
        <button @click="this.openEurorescue">rescue.euroncap.com/</button>


       <!-- <button v-if="1==2" id="controlButton" @click="switchMapControl()" class="fa">&#xf013;</button>
        <span id="mapControl" v-if="mapControlVisible">
            <button :class="randVisible ? 'buttonOn' : 'buttonOff'" @click="switchRandVisibility()">Rand</button>
        </span>-->
    </div>
    <!--<Footer backLink="/einsatz/" v-show="randVisible" />-->

    <!--<router-link :to="`/einsatz/`+this.$route.params.id"><button id="homeButton" class="mapButton"><img src="@/assets/Icons/HomeButton.svg"></button></router-link>-->
</template>

<script>
import Header from '@/components/Header.vue'

export default {
    name: 'EurorescueView',
    components: {
        Header,
    },
    data() {
        return {

        }
    },
    methods: {
        openEurorescue() {
            window.open("https://rescue.euroncap.com/", "_blank");
        }
    },
    created() {

    }
}
</script>

<style lang="scss" scoped>
#eurorescue {
  height: 90vh;
  width: 100vw;
  background-color: rgb(248, 248, 248);
  overflow:hidden;
  overflow-y: auto;

  h1{
    margin-top: 7rem;
  }

  button{
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: solid rgb(236, 236, 236) 1px;
    border-radius: 8px;
    background-color: #C00000;
    color: white;
  }
}
</style>
